// src/components/ui/Card.jsx — premium v8.3
export default function Card({ children, className = "", variant = "elevated", style = {} }) {
  const variants = {
    elevated: {
      background: "var(--bg-card)",
      border: "1px solid var(--border)",
      boxShadow: "var(--shadow)",
    },
    subtle: {
      background: "var(--bg-subtle)",
      border: "1px solid var(--border-subtle)",
      boxShadow: "none",
    },
    flat: {
      background: "transparent",
      border: "1px solid transparent",
      boxShadow: "none",
    },
    accent: {
      background: "var(--bg-card)",
      border: "1px solid var(--border-accent)",
      boxShadow: "var(--shadow), var(--shadow-glow)",
    },
  };

  return (
    <div
      className={className}
      style={{
        borderRadius: "var(--radius-lg)",
        transition: "border-color var(--t-normal), box-shadow var(--t-normal)",
        ...variants[variant] ?? variants.elevated,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
